module.exports = __webpack_public_path__ + "static/dg-3-fd3c5e59599cffcb7bf0008a4a6ee08a.png";